import React from 'react';
import AuxiliaryEquipmentAddEdit from './auxiliary-equipment-add-edit';
import AuxiliaryEquipmentAddEditModal from './auxiliary-equipment-add-edit-modal';

import { MODAL_TYPES } from 'Feature/components/app-modals';

const { AUXILIARY_EQUIPMENT_ADD_EDIT } = MODAL_TYPES;

const AuxiliaryEquipmentModals = () => {
  return (
    <>
      <AuxiliaryEquipmentAddEdit modalId={AUXILIARY_EQUIPMENT_ADD_EDIT} />
      <AuxiliaryEquipmentAddEditModal />
    </>
  );
};

export default AuxiliaryEquipmentModals;
